import {SagaIterator} from 'redux-saga';
import {takeLatest, select, put, all} from 'redux-saga/effects';

import {
    setOption,
    toggleOption,
} from 'features/wizardMs/reducers/customerConfiguration/customerConfiguration';
import {getAddAndUpdateCartDataForPrice} from 'features/wizardMs/selectors/product/product';
import {
    fetchDiscountPrice,
    setDiscountPriceData,
} from 'features/wizardMs/reducers/discountPrice/discountPrice';
import {PRODUCT} from 'constants/actions';
import {getWizard, fetchPackagesCoupon} from 'features/wizardMs/reducers/wizardData/wizardData';
import {
    getActiveProduct,
    isSoldOut,
    isContactLenses as isContactLensesSelector,
} from 'selectors/product/product';
import {getPage} from 'selectors/pageApp/pageApp.js';
/**
 * It requests price each time when customer choose some option on wizard ms
 */
export function* requestDiscountPrice() {
    const [isContactLenses, page] = yield all([select(isContactLensesSelector), select(getPage)]);
    if (isContactLenses || !['productEdit', 'product'].includes(page)) return;

    const [addToCartData, isSoldOutProduct] = yield all([
        select(getAddAndUpdateCartDataForPrice),
        select(isSoldOut),
    ]);
    if (!isSoldOutProduct) {
        yield put(
            fetchDiscountPrice({
                ...addToCartData,
            }),
        );
    }
}

/**
 *
 */
export function* setInitialDiscountPrice() {
    const activeProduct = yield select(getActiveProduct);
    yield put(
        setDiscountPriceData({
            status: 'fulfilled',
            coupon: activeProduct.appliedCoupon,
            finalPrice: activeProduct.finalPrice,
            price: activeProduct.price,
        }),
    );
}

/**
 * Root
 */
export function* discountPriceSaga(): SagaIterator {
    yield takeLatest(
        [
            `${setOption}`,
            `${toggleOption}`,
            PRODUCT.SET_ACTIVE_PRODUCT_ID,
            `${getWizard}_FULFILLED`,
            'GET_CMS_BLOCK_BY_ID_FULFILLED',
            `${fetchPackagesCoupon}_FULFILLED`,
        ],
        requestDiscountPrice,
    );
    yield takeLatest(`${PRODUCT.GET_PRODUCT}_FULFILLED`, setInitialDiscountPrice);
}
